import { render, staticRenderFns } from "./rate.vue?vue&type=template&id=bfc81f5e&scoped=true"
import script from "./rate.vue?vue&type=script&lang=js"
export * from "./rate.vue?vue&type=script&lang=js"
import style0 from "./rate.vue?vue&type=style&index=0&id=bfc81f5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc81f5e",
  null
  
)

export default component.exports